// Image COmponent
export function imageExist(proData) {
	let required   = proData.required;
	let url        = proData.url;
	let alt        = proData.alt;
	let ref        = proData.ref;
	let width      = proData.size?proData.size:proData.width;
	let height     = proData.size?proData.size:proData.height;
	let altImg     = proData.altImg;
	let style      = proData.style;
	let imageInfo = null;
	let className = proData.className?proData.className:'custom_img';
	let imgUrl = '';
   
	/* eslint-disable no-undef */
	imgUrl = require(`../../assets/img${required+url}`);
	/* eslint-enable no-undef */
     
	if((required)&&(url)){
		try {
			// imageInfo = <img src={require(`../../assests/images${required+url}`).default} alt={alt} className={className} width={size} height={size}/>
			imageInfo = <img ref={ref} src={imgUrl} onClick={proData.onClick} alt={alt} className={className} width={width} height={height} style={style}/>;
		}catch(e) {
			imageInfo = altImg?altImg:null;
		}
	}else{
		imageInfo = null;
	}
	return imageInfo;
};

//Amount Format
export const formatINR = (value, isPositive = false) => {
	let num = Number(value);

	if (isNaN(num)) { return value; } // fallback return

	// If positive mode is on, convert negative to positive
	if (isPositive && num < 0) {
		num = Math.abs(num);
	}

	return new Intl.NumberFormat('en-IN', {
		style: 'currency',
		currency: 'INR',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	}).format(num);
};

//Amount Short Format
export const amountFormatter = (amount) => {
	let formatted;
	if (amount >= 1e7) { // 1 Cr
		formatted = (amount / 1e7);
		return (formatted % 1 === 0 ? formatted : formatted?.toFixed(2)) + ' Cr';
	} else if (amount >= 1e5) { // 1 Lakh
		formatted = (amount / 1e5);
		return (formatted % 1 === 0 ? formatted : formatted?.toFixed(2)) + ' L';
	} else if (amount >= 1e3) { // 1 Thousand
		formatted = (amount / 1e3);
		return (formatted % 1 === 0 ? formatted : formatted?.toFixed(2)) + ' K';
	} else {
		return (amount % 1 === 0 ? amount : amount?.toFixed(2));
	}
};

//Input Helper Text
export const numberToWords = (num, unit = '') => {
	if (num === 0) return unit ? `Zero ${unit}` : 'Zero';

	const ones = [
		'', 'One', 'Two', 'Three', 'Four', 'Five',
		'Six', 'Seven', 'Eight', 'Nine', 'Ten',
		'Eleven', 'Twelve', 'Thirteen', 'Fourteen',
		'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
	];

	const tens = [
		'', '', 'Twenty', 'Thirty', 'Forty',
		'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
	];

	const scales = [
		{ value: 10000000, name: 'Crore' },
		{ value: 100000, name: 'Lakh' },
		{ value: 1000, name: 'Thousand' },
		{ value: 100, name: 'Hundred' }
	];

	function convert(n) {
		let result = '';
		for (const scale of scales) {
			if (n >= scale.value) {
				const count = Math.floor(n / scale.value);
				result += `${convert(count)} ${scale.name} `;
				n %= scale.value;
			}
		}
		if (n > 0) {
			if (n < 20) {
				const index = Math.min(Math.max(Math.floor(n), 0), ones.length - 1);
				result += ones[Number(index)];
			} else {
				result += tens[Math.floor(n / 10)];
				const rem = n % 10;
				if (rem > 0) {
					const index = Math.min(Math.max(Math.floor(rem), 0), ones.length - 1);
					result += ` ${ones[Number(index)]}`;
				}
			}
		}
		return result.trim();
	}
	const text = convert(num);
	return num ? `${text} ${unit || ''}` : '';
};
